import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import AddresseeInput from './AddresseeInput';
import { GenerateButton } from './GenerateButton';
import { ReportData } from './ReportData';
import { ctxReport } from '@/contexts/ReportCtx';
import ReportTargetSelector from './ReportTargetSelector';

import './TargetTab.css';

export default function TargetTab() {
  const { t } = useTranslation();
  const reportCtx = useContext(ctxReport);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (!reportCtx) return;
    const isDisabled = !reportCtx.selectedTargets || !reportCtx.selectedTargets.length;
    setDisabled(isDisabled);
  }, [reportCtx]);

  if (!reportCtx) return null;

  return (
    <div id="report-target-container">
      <div id="report-target-selector" data-qa-element-id="multi_element_selector_panel">
        <ReportTargetSelector />
      </div>
      <div id="target-report-data" className={disabled ? 'disabled' : ''} inert={disabled}>
        <Typography variant="h6" id="report-header-h3">
          {t('report.reportChooser')}
        </Typography>
        <ReportData isListView={false} />
        {reportCtx.selectedTemplateIds.length > 0 && (
          <div id="target-report-data-menu">
            <Stack direction="column">
              <Typography variant="h6" id="report-email-header">
                {t('report.emailHeader')}
              </Typography>
              <Typography variant="helperText">{t('report.emailComment')}</Typography>
              <AddresseeInput />
            </Stack>
            <Stack direction="column" className="report-button-conainer">
              <GenerateButton />
              <Typography variant="helperText" className="report-generate-comment">
                {t('report.sendComment')}
              </Typography>
            </Stack>
          </div>
        )}
      </div>
    </div>
  );
}
